/**
 * Body-weight and height units. Stored metric (kg, cm) always; the unit
 * preference comes from the Lift account and is display-only.
 */

export type Unit = 'kg' | 'lb'
export const LB_PER_KG = 2.20462262

export function kgToDisplay(kg: number | null | undefined, unit: Unit): number | null {
  if (kg === null || kg === undefined || !Number.isFinite(kg)) return null
  return unit === 'lb' ? kg * LB_PER_KG : kg
}

export function displayToKg(value: number | null | undefined, unit: Unit): number | null {
  if (value === null || value === undefined || !Number.isFinite(value)) return null
  return unit === 'lb' ? value / LB_PER_KG : value
}

export function formatWeight(kg: number | null | undefined, unit: Unit, decimals = 1): string {
  const v = kgToDisplay(kg, unit)
  if (v === null) return '—'
  return `${v.toFixed(decimals).replace(/\.0+$/, '')} ${unit}`
}

/** Signed rate per week, e.g. "−0.45 kg/wk". */
export function formatRate(kgPerWeek: number | null | undefined, unit: Unit): string {
  const v = kgToDisplay(kgPerWeek, unit)
  if (v === null) return '—'
  const s = Math.abs(v) < 0.005 ? '0.00' : Math.abs(v).toFixed(2)
  return `${v > 0.005 ? '+' : v < -0.005 ? '−' : ''}${s} ${unit}/wk`
}

export function cmToFtIn(cm: number): { ft: number; inch: number } {
  const total = cm / 2.54
  let ft = Math.floor(total / 12)
  let inch = Math.round(total - ft * 12)
  if (inch === 12) { ft++; inch = 0 }
  return { ft, inch }
}

export function ftInToCm(ft: number, inch: number): number {
  return Math.round((ft * 12 + inch) * 2.54 * 10) / 10
}
